// extracted by mini-css-extract-plugin
module.exports = {"heading":"aboutText_heading__AXgVt","aboutText":"aboutText_aboutText____cjM","aboutBox":"aboutText_aboutBox__AaqcH"};